import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  html, body {
    height: 100%;
  } 
  body {
    margin: 0;
    font-family: "Poppins", sans-serif;
  }
  #root {
    height: 100%;
  }
  .App {
    height: 100%;
  }
  
`;
